import { render } from "./ActivityFeatured.vue?vue&type=template&id=3e4a774d&ts=true"
import script from "./ActivityFeatured.vue?vue&type=script&lang=ts"
export * from "./ActivityFeatured.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__